<template>
  <div class="invoicePurchaseBox">
    <div v-show="!isSuccess && !isCreated" class="checkPay">
      <i class="iconfont icon-close close cursor" @click="closePurchaseBox()"></i>
      <div v-show="!showShouhuoBox" class="menu">
        <h3 class="mb-2">选择支付方式</h3>
        <p class="mb-3 description">{{orderInfo.title}}</p>
        <hr class="mb-4" style="border-color: rgba(0, 0, 0, 0.1);">
        <div class="lis mb-3">
          <span @click="checkPatType(1)" class="cursor" :class="{active:pay===1}">
            <img src="/static/images/aliPay.svg">
            支付宝支付
            <i class="iconfont icon-chenggong"></i>
          </span>
          <span @click="checkPatType(2)" class="cursor" :class="{active:pay===2}">
              <img src="/static/images/wechatPay.svg">
              微信支付
              <i class="iconfont icon-chenggong"></i>
            </span>
        </div>
        <button v-if="pay===1" class="btn-success btn btn-round btn-lg" @click="submitFun">
          <i v-if="isLoading" class='iconfont icon-jiazai xuanzhuan'></i>
          立即支付
        </button>
        <button v-if="pay===2" disabled class="btn btn-round btn-lg btn-secondary">
          <i v-if="isLoading" class='iconfont icon-jiazai xuanzhuan'></i>
          微信扫描码支付...
        </button>
        <span @click="submitFunB" v-if="pay===3" class="btn btn-round btn-lg btn-success">
          <i v-if="isLoading" class='iconfont icon-jiazai xuanzhuan'></i>
          前往支付
        </span>
      </div>
      <div class="price" :class="{'bg-success':pay===2,'bg-primary':pay===1}">
        <h2 class="m-0 a" v-if="pay===1">￥{{orderInfo.price}}</h2>
        <img class="mb-3 img-thumbnail" v-if="pay===2 && !isWxpayLoading && isWxpayLoadingSuccess" :src="base64">
        <i v-if="pay===2 && isWxpayLoading" class='iconfont icon-jiazai xuanzhuan'></i>
        <h2 class="m-0 b" v-if="pay===2">￥{{orderInfo.price}}</h2>
        <h2 class="m-0 c" v-if="pay===3">￥{{orderInfo.price}}</h2>
      </div>
    </div>
    <div v-show="isSuccess && !isCreated" class="checkPay successBox">
      <h1 v-if="!isPaybool"><i class='iconfont icon-jiazai xuanzhuan'></i> 支付中...</h1>
      <h1 v-else class="text-success"><i class='iconfont icon-chenggong text-success'></i> 支付成功</h1>
      <p>
        <span v-if="!isPaybool" @click="closeRightBoxFun(true)" class="btn btn-outline-success btn-lg">支付成功</span>
        <span v-else @click="closeRightBoxFun(true)" class="btn btn-outline-success btn-lg">前往发票管理中心</span>
        <span @click="closePurchaseBox()" class="btn btn-secondary btn-lg">关闭窗口</span>
      </p>
      <p class="description m-0">
        — 支付遇到问题请联系客服 —
      </p>
    </div>
    <div v-show="isCreated" class="createBox">
      <i class='iconfont icon-jiazai xuanzhuan'></i>
      <p>创建开票申请中~</p>
    </div>
  </div>
</template>

<script>
import 'vue-multiselect/dist/vue-multiselect.min.css';
import generalMix from '@/util/mix/general';
import { EventBus } from '@/util/eventBus';
import resultcommons from '../../util/resultcommons';
import commons from '@/util/commons';
import * as types from '@/store/types';

export default {
  name: 'invoicePurchaseBox',
  props:['closePurchaseBox','parms','closeRightBoxFun'],
  mixins: [generalMix],
  data () {
    return {
      pay:1,
      isLoading:false,// 立即支付按钮 加载 图标
      isSuccess:false,// 是否点击了立即支付按钮
      isCreated:true,// 是否创建了订单目录
      isPaybool:false,// 是否支付成功了
      isWxpayLoading:true, // 加载二维码
      isWxpayLoadingSuccess:false, // 二维码加载成功
      base64:'',
      baseUrl: process.env.PAYMENT_BASE_URL,
      orderInfo:{},
      shouhuoBool:false, // 确认过收获则为true
      showShouhuoBox:false
    }
  },
  methods:{
    // 登录
    loginFun() {
      EventBus.$emit('globalLoadingFun', {bool:true,loading:false});
      this.isLoading = true;
      // 更新本地缓存
      const localOb = this.localUser;
      localOb.invoiceInfo.mailName = this.mailName;
      localOb.invoiceInfo.mailPhone = this.mailPhone;
      localOb.invoiceInfo.mailAddress = this.mailAddress;
      // 可以执行登录
      resultcommons.apiSaveinvoiceinfo(this, { type:4,no:this.orderInfo.no,token: this.localUser.token, ...localOb.invoiceInfo }).then(app=>{
        if(app.state === 200){
          commons.saveTodos('localUser', localOb);
          // 更新本地路由的登录信息
          this.$store.commit(types.SAVE_LOCALUSER, { bool: true });
          EventBus.$emit('globalLoadingFun', {bool:false,loading:false});
          this.isLoading = false;
          // 切换为修改成功页面
          this.showShouhuoBox = false;
          this.shouhuoBool = true;
        }else{
          EventBus.$emit('globalLoadingFun', {bool:false,loading:false});
          this.isLoading = false;
          this.$message.showMsgBox({ type: 'warning', content: app.message });
        }
      });
    },
    checkPatType(type) {
      this.pay = type;
      // 如果是微信则请求支付二维码
      if(type === 2) {
        // 微信支付
        this.isWxpayLoading = true;
        this.isWxpayLoadingSuccess = false;
        resultcommons.apiWechatpay(this,{no:this.orderInfo.no}).then(app=>{
          if(app.state === 200){
            this.base64 = app.data.base64;
            this.isWxpayLoading = false;
            this.isWxpayLoadingSuccess = true;
            // 创建定时任务
            Window.timerUploadOrder = setInterval(() => {
              this.timerUploadOrder();
            }, 3000);
          }else{
            this.$message.showMsgBox({
              type: 'warning',
              content: app.message
            });
          }
        });
      }else{
        clearInterval(Window.timerUploadOrder);
      }
    },
    // 更新订单支付状态
    timerUploadOrder() {
      // 支付成功
      resultcommons.apiOrdercatalogstate(this,{no:this.orderInfo.no}).then(app=>{
        if(app.state === 200){
          if(app.data.state !== '0'){
            this.isPaybool = true;
            this.isSuccess = true;
            clearInterval(Window.timerUploadOrder);
          }
        }
      });
    },
    submitFun() {
      // 加载中
      this.isLoading = true;
      // 跳转成功
      this.isSuccess = true;
      // 创建定时任务
      Window.timerUploadOrder = setInterval(() => {
        this.timerUploadOrder();
      }, 3000);
      // 执行跳转
      window.open(this.baseUrl + '/alipay/pagepay.html?no=' + this.orderInfo.no, '_blank');
    },
    submitFunB() {
      // 加载中
      this.isLoading = true;
      // 跳转成功
      this.isSuccess = true;
      // 创建定时任务
      Window.timerUploadOrder = setInterval(() => {
        this.timerUploadOrder();
      }, 3000);
      // 执行跳转
      window.open('/paypal/' + this.orderInfo.no, '_blank');
    }
  },
  components: {
  },
  created() {
    // 预定义订单
    this.isCreated = true;
    EventBus.$emit('globalLoadingFun', {bool:true,loading:false});
    this.parms.type = 'invoice';
    resultcommons.apiOrdercatalog(this,{...this.parms}).then(app=>{
      EventBus.$emit('globalLoadingFun', {bool:false,loading:false});
      if(app.state === 200){
        this.orderInfo = app.data;
        this.isCreated = false;
      }else{
        this.$message.showMsgBox({
          type: 'warning',
          content: app.message
        });
        // 关闭表单弹框
        this.isCreated = false;
        this.closePurchaseBox();
      }
    });
  },
  mounted() {
  },
  destroyed() {
    clearInterval(Window.timerUploadOrder);
  }
}
</script>

<style scoped lang='less'>

.invoicePurchaseBox {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  background: rgba(255,255,255,.03);
  filter: blur(0);
  backdrop-filter: blur(.52632rem);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  overflow-y: auto;
  color: #000000;
  .btn{
    &.bg-paypal{
      border-color: #0544B5;
      background: #0544B5;
      &:hover{
        background: #025DCE;
      }
    }
  }
  div.successBox{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    h1{
      color: #FF5630;
      i{
        font-size: 56px;
      }
    }
    span{
      margin-top: 30px;
      margin-bottom: 10px;
    }
    p{

    }
  }
  div.createBox{
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #FFFFFF;
    width: 80vw;
    height: 60vh;
    min-height: 350px;
    border-radius: 5px;
    padding: 15px;
    border: 5px solid #242424;
    margin-top: 10vh;
    margin-bottom: 10vh;
    i{
      font-size: 56px;
      font-weight: bold;
      margin-bottom: 30px;
      color: #007BFF;
    }
    p{
      margin: 0;
    }
  }
  div.checkPay{
    background: #FFFFFF;
    width: 80vw;
    height: 60vh;
    min-height: 350px;
    border-radius: 5px;
    padding: 15px;
    border: 5px solid #242424;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10vh;
    margin-bottom: 10vh;
    i.close{
      position: absolute;
      top: 25px;
      right: 25px;
      font-size: 28px;
      color: #FFFFFF;
    }
    div.menu{
      flex: 1;
      margin-right: 20px;
      div.shouhuoBox{
      }
      div.lis{
        span{
          position: relative;
          margin-right: 20px;
          border: 3px solid rgba(255, 255, 255, 0.2);
          background: rgba(0, 0, 0, 0.3);
          background: #FFFFFF;
          padding: 8px 15px;
          display: inline-block;
          border-radius: 5px;
          margin-bottom: 10px;
          color: #000000;
          &.active{
            border: 3px solid #28A745;
            i{
              display: block;
            }
          }
          img{
            height: 25px;
          }
          &:last-child{
            margin: 0;
          }
          i{
            display: none;
            color: #28A745;
            position: absolute;
            right: -3px;
            bottom: -4px;
          }
        }
      }
    }
    div.price{
      height: 100%;
      min-height: 100px;
      background: #FF5630;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-radius: 10px;
      color: #FFFFFF;
      h2.a{
        font-size: 58px;
      }
      h2.b{
        font-size: 22px;
      }
      h2.c{
        font-size: 58px;
      }
      img{
        width: 160px;
        //border-radius: 5px;
      }
      i.icon-jiazai{
        font-size: 60px;
        margin-bottom: 20px;
      }
      &.bg-paypal{
        background: #0544B5;
      }
    }
  }
}

@media (max-width: 992px) {
  div.purchaseBox{
    display: block;
    div.checkPay{
      flex-direction: column;
      height: auto;
      min-height: auto;
      display: flex;
      margin-left: auto;
      margin-right: auto;
      div.price{
        width: 100%;
        margin-top: 20px;
        font-size: 36px;
        font-weight: bold;
        padding: 30px 0;
        padding-bottom: 20px;
        div.meiyuan{
          margin-top: 15px;
        }
      }
    }
  }
}

@media (max-width: 776px) {
}

</style>



// WEBPACK FOOTER //
// src/components/common/invoicePay.vue